export default "__VITE_ASSET__CQGInioj__";